const TYPES = {
  APP_RESIZE: 'APP_RESIZE',
  FETCH_BOOTSTRAP: 'FETCH_BOOTSTRAP',
};

export default TYPES;
